import axios from "axios";

const axiosClient = axios.create({
    baseURL: `${process.env.REACT_APP_URL}`
});

// eslint-disable-next-line space-before-function-paren
export function getPosts(params) {
    return axiosClient.get("/getTagArticles", { params: params });
};
